/* eslint-disable @wyz/module/no-relative-import */
import { Button, FormGroup, Icon, Label } from '@wyz/ui';
import { useNavigate } from 'react-router';
import { Trans, useI18n } from '~/common/context';
import { TranslationKeys } from '~/common/types';

import { COMPLETE_WHEEL_VEHICLE_TYPE } from '~/purchase/helpers';
import './vehicle-type-group-toggle.scss';
import { usePurchaseContext } from '~/purchase/context';

type VehicleTypeGroup = {
  name: string;
  i18nKey: string;
  vehicleTypeIds: Array<string>;
};

type VehicleTypeGroupToggleProps = {
  groups: Array<VehicleTypeGroup>;
  activeGroup: string | undefined;
  onSelectGroup: (group: VehicleTypeGroup) => void;
};

function VehicleTypeGroupToggle({
  groups,
  activeGroup,
  onSelectGroup,
}: VehicleTypeGroupToggleProps) {
  const { t } = useI18n();
  const navigate = useNavigate();
  const purchaseContext = usePurchaseContext();
  const handleClick = (group: VehicleTypeGroup) => {
    if (activeGroup === group.name) {
      return;
    }

    const BASE_ROUTE_LOOKUP: Record<typeof purchaseContext.mode, string> = {
      CALL_CENTER: '/call-center',
      PURCHASE: '/purchase',
      QUOTE: '/quotes/search',
      PRICING_POLICY: '/purchase', // won't be needed
    };
    const baseRoute = BASE_ROUTE_LOOKUP[purchaseContext.mode] ?? '/purchase';
    if (group.name === COMPLETE_WHEEL_VEHICLE_TYPE) {
      void navigate(`${baseRoute}/wcw/search`);
    } else {
      void navigate(baseRoute);
      onSelectGroup(group);
    }
  };

  const isPurchase = purchaseContext.mode === 'PURCHASE';
  return (
    <FormGroup>
      <Label className='required'>
        <Trans i18nKey='app.purchase.search_page.vehicle_type' />
      </Label>
      <div>
        <div className='vehicle-type-group-toggle__group'>
          {groups
            // COMPLETE_WHEEL_VEHICLE_TYPE only allowed in purchase mode
            .filter((group) =>
              isPurchase ? true : group.name !== COMPLETE_WHEEL_VEHICLE_TYPE,
            )
            .map((group) => (
              <Button
                id={`vehicle-type-group-toggle-${group.name}`}
                variant='default'
                key={group.name}
                type='button'
                className={`vehicle-type-group-toggle__button${
                  group.name === activeGroup
                    ? ' vehicle-type-group-toggle__button--active'
                    : ''
                }`}
                onClick={() => handleClick(group)}
              >
                <Icon icon='car-line' size='xs' />
                {t(group.i18nKey as keyof TranslationKeys, {
                  defaultValue: group.name,
                })}
              </Button>
            ))}
        </div>
      </div>
    </FormGroup>
  );
}

export default VehicleTypeGroupToggle;
